import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { OAuthHttpClient } from '../../services/o-auth-http-client';
import { OAuthClientActions } from './o-auth-client.store';

@Injectable({ providedIn: 'root' })
export class OAuthClientEffects {
  public effect = createEffectFactory(OAuthClientActions, this.actions$);

  public fetch$ = this.effect(OAuthClientActions.fetchOne, ({ payload }) =>
    this.oAuthHttpClient.loadClient(payload.id).pipe(map(data => ({ data }))),
  );

  constructor(
    private actions$: Actions,
    private oAuthHttpClient: OAuthHttpClient,
  ) {}
}
